import { Grid, Typography } from "@material-ui/core";
import { Status } from "../../../models/gameplan";
import { Navigation } from "../../../models/navigation";
import { TabsLayout } from "../../../shared/components";
import { Header } from "../../../shared/components/header";
import { CompletedListIcon } from "../../../shared/icons/CompletedList.icon";
import { ListIcon } from "../../../shared/icons/List.icon";
import { AllQuickWinsList } from "../../components/all-quick-wins-list/all-quick-wins-list.component";
import { QuickWinsContainerStyles } from "./quick-wins-container.styles";

interface QuickWinsContainerProps {
  navigation: Navigation[];
}

export const QuickWinsContainer = ({ navigation }: QuickWinsContainerProps) => {
  const classes = QuickWinsContainerStyles();

  const allTitle = (
    <Typography className={classes.tabTitle}>
      <ListIcon /> All Quick Wins
    </Typography>
  );

  const completedTitle = (
    <Typography className={classes.tabTitle}>
      <CompletedListIcon /> Completed
    </Typography>
  );

  return (
    <Header navigation={navigation}>
      <Grid container>
        <Grid item xs={12}>
          <Typography
            variant="h2"
            color="textPrimary"
            component="h1"
            className={classes.sectionTitle}
            data-testid="quickWinsContainerTitle"
          >
            Quick Wins
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TabsLayout
            listComponents={[
              {
                slug: "/participant/quick-wins",
                label: allTitle,
                component: <AllQuickWinsList />,
              },
              {
                slug: "/participant/quick-wins/Completed",
                label: completedTitle,
                component: <AllQuickWinsList filteredBy={Status.COMPLETED} />,
              },
            ]}
          />
        </Grid>
      </Grid>
    </Header>
  );
};
